<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Out / In Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="inout_date"/></span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<!-- <a href="javascript:;" class="gray_bt" @click="reset()">Reset</a> -->
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big3_tbl">
				<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
					<thead>
						<tr>
							<th style="text-align:center;width:5%;">S. No.</th>
							<th style="text-align:center;width:10%;">Date</th>
							<th style="text-align:center;width:5%;">Type</th>
							<th style="text-align:center;width:15%;">Sales Group</th>
							<th style="text-align:center;width:10%;">Tot. Qty</th>
							<th style="text-align:center;">Description</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="s in sampleInouts" v-bind:key="s.sample_inout_no" v-bind:class="{ on: s.sample_inout_no == selectedSampleInout.sample_inout_no }" @click="selectRow(s)">
							<td style="text-align:right;">{{ s.sample_inout_no }}</td>
							<td>{{ s.inout_date }}</td>
							<td class="al_center">{{ s.inout_type }}</td>
							<td>{{ s.sales_group_name }}</td>
							<td style="text-align:right;">{{ s.total_quantity | commaSeparated }}</td>
							<td class="truncate">{{ s.description }}</td>
						</tr>
					</tbody>
				</table>

				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<a v-if="modifiable" href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
				</div>
			</div>

			<div class="right_small3_tbl" style="height:800px;">
				<div>
					<h4 class="inner_h5">{{ detailTitle }}</h4>
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:80px;" />
							<col style="width:90px;" />
							<col style="width:60px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Date</th>
								<td>
									<CustomDatePicker v-model="sampleInout.inout_date" />
								</td>
								<th>Type</th>
								<td>
									<label class="mgr_10"><input type="radio" value="O" v-model="sampleInout.inout_type" /> Out</label>
									<label class="mgr_10"><input type="radio" value="I" v-model="sampleInout.inout_type" /> In</label>
								</td>
							</tr>
							<tr>
								<th>Sales Group</th>
								<td colspan="3">
									<CodeSelect className="tbl_select" :codes="salesGroups" v-model="sampleInout.sales_group_code" />
								</td>
							</tr>
							<tr>
								<th>Description</th>
								<td colspan="3">
									<input type="text" v-model.trim="sampleInout.description" class="tbl_int full_int" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="true">
					<h4 class="inner_h5">
						<template v-if="modifiable && mode == 'add'">
							Item<input type="text" v-model.trim="barcode" class="tbl_int mgl_15" style="width:150px;margin-right:20px;" placeholder="Barcode" @keypress.enter="findItemAndAdd()" />
							<a href="javascript:;" class="search_bt" @click="searchItem()">Search and Add Item(s)</a>
						</template>
					</h4>

					<div class="fixed-table-container" style="height:600px;">
						<div class="table-wrapper">
							<table id="item_list" class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:15%;">
											<div class="th-text">{{ headers.class }} Code</div>
										</th>
										<th style="text-align:center;width:10%;"><div class="th-text">WH Code</div></th>
										<th style="text-align:center">
											<div class="th-text">{{ headers.class }} Name</div>
										</th>
										<th style="text-align:center;width:15%;"><div class="th-text">Color</div></th>
										<th style="text-align:center;width:12%;"><div class="th-text">Barcode</div></th>
										<th style="text-align:center;width:7%;"><div class="th-text">Qty</div></th>
										<th style="text-align:center;width:7%;"><div class="th-text">OnHand</div></th>
										<th style="text-align:center;width:3%;"><div class="th-text">Active</div></th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="item in items" v-bind:key="item.item_id">
										<td>{{ item.class_code }}</td>
										<td>{{ item.wh_class_code }}</td>
										<td>{{ item.class_name }}</td>
										<td>{{ item.color_code }}</td>
										<td>{{ item.barcode }}</td>
										<td class="al_right">
											<currency-input type="text" ref="quantity" v-model="item.quantity" class="r_int long_type al_right" :precision="0" @focus="$event.target.select()" :valueRange="{ min: 0 }" />
										</td>
										<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
										<td class="al_center"><input type="checkbox" id="active_yn" v-model="item.active_yn" true-value="Y" false-value="N" disabled /></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="view_bottom_bt">
							<a v-if="modifiable && mode == 'add'" href="javascript:;" class="search_bt" @click="save()">Save</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ItemSelect'" :draggable="false" style="z-index:2000">
			<template slot="title">Select Item(s)</template>
			<template slot="body">
				<ItemPopupSample operation="S" invoice_type="R" :initialItems="searchItems" :initialItemClass="null" :initialKeyword="null" @close="closeModal()" @set-items="addItems" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectSampleInoutList, apiSelectSampleInout, apiInsertSampleInout } from '@/api/sales/sample.js';
import { apiSelectItem } from '@/api/item/master.js';
import _ from 'lodash';

import Paging from '@/components/common/Paging';
import CodeSelect from '@/components/common/CodeSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import ItemPopupSample from '@/components/common/ItemPopupSample';
import Modal from '@/components/common/Modal';
// import ItemDetail from '@/components/common/ItemDetail';
import '@/assets/css/table_box.css';
import { today } from '@/utils/date.js';

export default {
	props: ['headers'],
	data: function() {
		return {
			inout_date: today(),
			sales_group_code: null,

			salesGroups: [],

			sampleInouts: [],

			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			mode: null,

			selectedSampleInout: {},

			sampleInout: {},

			items: [],
			searchItems: [],

			barcode: null,

			modalName: '',
			showModal: false,
			// new_item: {},
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		CodeSelect,
		CustomDatePicker,
		ItemPopupSample,
		Modal,
	},
	methods: {
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		addItems(items) {
			this.mergeItems(items);
		},
		mergeItems(items) {
			var vm = this;
			items.forEach(function(item) {
				var foundItems = vm.items.filter(i => i.item_id == item.item_id);
				if (foundItems.length > 0) foundItems[0].quantity += item.quantity;
				else vm.items.push(_.cloneDeep(item));
			});
		},
		async searchItem() {
			this.openModal('ItemSelect');
		},
		async findItemAndAdd() {
			//console.log('finding ' + this.barcode);

			const { data } = await apiSelectItem({
				barcode: this.barcode,
			});
			//console.log(data);
			if (data.item) {
				if (this.items.filter(i => i.item_id == data.item.item_id).length > 0) {
					this.items.filter(i => i.item_id == data.item.item_id)[0].quantity++;
				} else {
					data.item.quantity = 1;
					this.items.push(data.item);
				}
				//console.log(data.item);
				//this.item = data.item;

				this.barcode = null;

				return;
			} else {
				this.$toast.error('Item Not Found');
				return false;
			}
		},
		add() {
			this.mode = 'add';

			this.sampleInout = {
				inout_date: today(),
				inout_type: null,
			};

			this.items = [];
			this.selectedSampleInout = {};
			//this.$refs.code.focus();
		},

		search() {
			this.page_no = 1;
			this.selectSampleInoutList();
		},
		reset() {},
		async selectSampleInoutList() {
			this.mode = 'detail';
			this.sampleInout = {};
			this.selectedSampleInout = {};

			const { data } = await apiSelectSampleInoutList({
				inout_date: this.inout_date,
				sales_group_code: this.sales_group_code,

				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
			});

			//console.log(data);
			this.sampleInouts = data.sampleInoutList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
			//this.$router.replace('/item/item_class?active_yn=' + this.active_yn + 'closed_yn=' + this.closed_yn + '&page_no=' + this.page_no).catch(err => err);

			//if (this.itemClasses.length > 0) this.selectRow(this.itemClasses[0]);
		},
		async save() {
			if (!this.sampleInout.inout_date) {
				this.$toast.error('Invalid Date');
				return;
			}

			if (!this.sampleInout.inout_type) {
				this.$toast.error('Select Type');
				return;
			}

			if (!this.sampleInout.sales_group_code) {
				this.$toast.error('Select Sales Group');
				return;
			}

			var valid_items = this.items.filter(i => i.quantity > 0);
			if (valid_items.length == 0) {
				this.$toast.error('Nothing to save');
				return;
			}

			var total_quantity = 0;
			valid_items.forEach(i => {
				total_quantity += i.quantity;
			});

			this.sampleInout.total_quantity = total_quantity;
			this.sampleInout.items = valid_items;

			//console.log(this.sampleInout);
			const { data } = await apiInsertSampleInout(this.sampleInout);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.sampleInout.sample_inout_no = data.sample_inout_no;

				//this.sampleInout.sales_group_name = this.salesGroupList
				if (this.salesGroups.filter(sg => sg.code == this.sampleInout.sales_group_code).length > 0) {
					this.sampleInout.sales_group_name = this.salesGroups.filter(sg => sg.code == this.sampleInout.sales_group_code)[0].name;
				}
				this.sampleInouts.unshift(_.cloneDeep(this.sampleInout));
				Object.assign(this.selectedSampleInout, this.sampleInout);

				//this.selectRow(this.selectedSampleInout);
			} else {
				this.$toast.error(data.msg);
			}

			this.mode = 'detail';
		},
		setItem(sampleInout) {
			Object.assign(this.selectedSampleInout, sampleInout);
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			// this.selectItemClasses();
		},
		selectRow(sampleInout) {
			this.mode = 'detail';
			this.selectedSampleInout = sampleInout;
			this.sampleInout = _.cloneDeep(sampleInout);

			this.selectItem(this.sampleInout.sample_inout_no);
		},
		async selectItem(sample_inout_no) {
			const { data } = await apiSelectSampleInout({
				sample_inout_no: sample_inout_no,
			});

			//console.log(data);
			this.items = data.sampleInoutItemList;
			//this.items.push({ color_code: '', active_yn: 'Y' });
			//console.log(this.items);
		},
		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
		},
		async init() {
			await this.index();

			if (this.$route.query.inout_date) this.inout_date = this.$route.query.inout_date;
			await this.selectSampleInoutList();

			if (this.$route.query.sample_inout_no) {
				const { data } = await apiSelectSampleInout({
					sample_inout_no: this.$route.query.sample_inout_no,
				});
				this.selectedSampleInout = data.sampleInout;
				this.sampleInout = data.sampleInout;

				this.items = data.sampleInoutItemList;
			}
		},
	},
	created() {
		//this.$store.sideIndex = 1;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_1';
		this.$store.commit('setSelectedMenu', 'nav_li_sample');
		this.$store.commit('setSubTitle', 'Sales -> Sample Out / In');
	},
	mounted() {
		inputSelectOnClick();
		this.init();
	},
};
</script>

<style></style>
